import React, {Component} from "react"
import {
    auth_with_google,
    clear_forgot_password_status,
    clear_login_error,
    clear_password_change_status,
    clear_register_success,
    login,
    set_auth_errors
} from "../../actions/auth";
import {connect} from "react-redux";
import {Link, Redirect, withRouter} from "react-router-dom";
import {get_clusters} from "../../actions/clusters";
import Button from '@mui/material/Button/index';
import withStyles from "@mui/styles/withStyles";
import CardContent from "@mui/material/CardContent/index";
import SnackbarMessage from "../Custom/SnackbarMessage";
import TextField from "@mui/material/TextField";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import {switchMode} from "../../actions/theming";
import {GoogleLogin} from '@react-oauth/google';
import HowItWorks from "../Dialogs/HowItWorks";

const styles = {
    loginPage: {
        height: "calc(95vh - 40px)",
        paddingTop: "5vh",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
    },
    password: {
        "margin-top": 20
    },
    centered: {
        "text-align": "center",
        "paddingTop": 24,
        "paddingBottom": 24
    },
    loginWrapper: {
        textAlign: "center",
        paddingTop: "60px",
        //minHeight: "100vh",
        marginBottom: "60px",
        minHeight: "calc(100vh - 83px)",
        position: "relative"
    },
    logo: {
        paddingTop: 15,
        paddingBottom: 15,
        fontWeight: "bold",
        color: "white"
    },
    loginHint: {
        flex: "auto"
    },
    buttonIcon: {
        position: "absolute",
        left: "10px",
        width: "24px",
        height: "24px"
    },
    forgotPasswordLink: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    forgotPasswordContainer: {
        textAlign: "right",
        padding: "5px 0 0"
    },
    darkModeSwitch: {
        position: "fixed",
        top: "10px",
        right: "10px"
    }
};


class Login extends Component {


    constructor(props) {
        super(props);
        this.state = {
            emailTouched: false,
            passwordTouched: false,
            email: "", // admin@voca.click
            password: "", // admin
            redirect_status: window.REDIRECT_STATUS,
            howItWorksOpened: false
        };
    }

    componentDidMount() {
        if (window.PASSWORD_RESET) {
            if (!("type" in window.PASSWORD_RESET && window.PASSWORD_RESET.type === "error")) {
                this.props.history.push("reset-password");
            }
        }
    }

    onGoogleResponse = (response) => {
        if ("error" in response) {
            console.log(response);
            if ("details" in response) {
                this.props.set_auth_errors("google", response.details);
            }
        } else {
            // success
            this.props.auth_with_google(response.credential);
        }
    }

    // onFacebookResponse = (response) => {
    //     if ("name" in response && "email" in response && "accessToken" in response) {
    //         // success
    //         this.props.auth_with_facebook(response.accessToken);
    //     } else {
    //         this.props.set_auth_errors("facebook", "E-mail is not present on this Facebook account.");
    //         // todo toast error when email is not present
    //     }
    // }

    onSubmit = e => {
        e.preventDefault();
        if (!this.props.auth.is_logged && this.state.password.trim().length > 0 && this.state.email.trim().length > 0) {
            this.props.login(this.state.email, this.state.password);
        }
    };

    onChange = e => this.setState({

        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    isEmailValid = () => {
        return this.state.email.trim().length > 0 && this.state.email.includes('@');
    };

    isPasswordValid = () => {
        return this.state.password.trim().length > 0;
    };

    clear_redirect_status = e => this.setState({
        ...this.state,
        redirect_status: false
    });

    openHowItWorks = () => {
        this.setState({
            ...this.state,
            howItWorksOpened: true
        });
    };

    closeHowItWorks = () => {
        this.setState({
            ...this.state,
            howItWorksOpened: false
        });
    };

    render() {
        const {classes} = this.props;
        if (this.props.auth.is_logged) {
            // ACTIONS AFTER LOGIN
            //this.props.get_clusters();
            return <Redirect to="/home"/>
        } else {
            let errors, redirect_status, password_reset_message, forgot_password_message, register_success_message;
            if (Object.keys(this.props.auth.errors).length > 0) {
                let errors_array = [];
                Object.keys(this.props.auth.errors).map((field) => {
                    errors_array = [...errors_array, ...this.props.auth.errors[field]];
                });
                errors = (
                    <>
                        <SnackbarMessage onClose={this.props.clear_login_error} type="error"
                                         message={errors_array.join(", ")} autoHideDuration={null} anchorOrigin={false}
                                         style={{marginBottom: 30}}/>
                    </>
                )
            } else {
                errors = false
            }
            if (this.state.redirect_status) {
                redirect_status = (
                    <>
                        <SnackbarMessage onClose={this.clear_redirect_status} type={this.state.redirect_status.type}
                                         message={this.state.redirect_status.message} autoHideDuration={null}
                                         anchorOrigin={false}
                                         style={{marginBottom: 30}}/>
                    </>
                );
            }

            if (window.PASSWORD_RESET && "type" in window.PASSWORD_RESET && window.PASSWORD_RESET.type === "error") {
                password_reset_message = (
                    <>
                        <SnackbarMessage onClose={() => {
                            window.PASSWORD_RESET = false;
                            this.forceUpdate();
                        }} type={"error"}
                                         message={window.PASSWORD_RESET.message} autoHideDuration={null}
                                         anchorOrigin={false}
                                         style={{marginBottom: 30}}/>
                    </>
                );
            } else {
                if (this.props.auth.password_changed) {
                    // todo dismiss tejto spravy ak je to info tak to akosi nejde
                    password_reset_message = (
                        <>
                            <SnackbarMessage onClose={this.clear_password_change_status} type={"info"}
                                             message={this.props.auth.password_changed.message} autoHideDuration={null}
                                             anchorOrigin={false}
                                             style={{marginBottom: 30}}/>
                        </>
                    );
                }
            }

            if (this.props.auth.forgot_password && this.props.auth.forgot_password.status !== "error") {
                // todo dismiss tejto spravy ak je to info tak to akosi nejde
                forgot_password_message = (
                    <>
                        <SnackbarMessage onClose={this.clear_forgot_password_status} type={"info"}
                                         message={this.props.auth.forgot_password.message} autoHideDuration={null}
                                         anchorOrigin={false}
                                         style={{marginBottom: 30}}/>
                    </>
                );
            }

            if (this.props.auth.register_success) {
                // todo dismiss tejto spravy ak je to info tak to akosi nejde
                register_success_message = (
                    <>
                        <SnackbarMessage onClose={this.clear_register_success} type={"info"}
                                         message={this.props.auth.register_success} autoHideDuration={null}
                                         anchorOrigin={false}
                                         style={{marginBottom: 30}}/>
                    </>
                );
            }
            let content;
            if (this.props.auth.is_waiting) {
                content = (
                    <CardContent className={classes.centered}>
                        <CircularProgress/>
                    </CardContent>
                );
            } else {
                const {email, password, emailTouched, passwordTouched} = this.state;
                content = (
                    <>
                        <HowItWorks open={this.state.howItWorksOpened} closeHandle={this.closeHowItWorks.bind(this)}/>
                        <form onSubmit={this.onSubmit} id="login">
                            <CardContent style={{marginTop: "10px"}}>
                                {redirect_status}
                                {errors}
                                {password_reset_message}
                                {forgot_password_message}
                                {register_success_message}
                                <TextField autoFocus fullWidth label="E-mail" variant="outlined" type="email"
                                           name="email"
                                           onChange={this.onChange} required
                                           error={emailTouched && !this.isEmailValid()}
                                           helperText={emailTouched && !this.isEmailValid() ? "Please enter a valid e-mail" : ""}
                                           value={email}
                                />
                                <TextField fullWidth className={classes.password} label="Password" variant="outlined"
                                           required
                                           type="password" error={passwordTouched && !this.isPasswordValid()}
                                           helperText={passwordTouched && !this.isPasswordValid() ? "Please enter a password" : ""}
                                           name="password" onChange={this.onChange} value={password}
                                />
                                <div className={classes.forgotPasswordContainer}>
                                    <Typography>
                                    <span
                                        className={classes.forgotPasswordLink} onClick={() => {
                                        this.props.clear_forgot_password_status();
                                        this.props.history.push("/auth/forgot-password");
                                    }}
                                    >
                                        Forgot password?
                                    </span>
                                    </Typography>

                                </div>
                                <Button type="submit"
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        style={{marginTop: "20px", width: "100%"}}
                                        disabled={!this.isEmailValid() || !this.isPasswordValid()}
                                >
                                    Log in
                                </Button>

                                <Divider variant="middle" style={{margin: "20px 0"}}/>
                                {/*<Typography style={{marginBottom: "20px", textAlign: "center"}}>Or</Typography>*/}
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                }}
                                     id="google-login-button"
                                >
                                    <GoogleLogin
                                        clientId="183543105985-i9e1htanv4grjndeiam1m4ger8b7booc.apps.googleusercontent.com"
                                        buttonText="Login"
                                        onSuccess={this.onGoogleResponse}
                                        onFailure={this.onGoogleResponse}
                                        callback={this.onGoogleResponse}
                                        cookiePolicy={'single_host_origin'}
                                        width={window.innerWidth < 400 ? "" : 360}
                                        // theme={"filled_black"}
                                        useOneTap
                                    />
                                </div>
                                <Button type="button"
                                        variant="contained"
                                        size="large"
                                        style={{
                                            marginTop: "10px",
                                            width: "100%",
                                            background: "rgb(0, 0, 204)",
                                            color: "white"
                                        }}
                                        onClick={this.openHowItWorks.bind(this)}
                                >
                                    HOW IT WORKS
                                </Button>
                                {/*<FacebookLogin*/}
                                {/*    appId="1167171010409939"*/}
                                {/*    autoLoad={false}*/}
                                {/*    fields="name,email"*/}
                                {/*    callback={this.onFacebookResponse}*/}
                                {/*    render={*/}
                                {/*        renderProps => (*/}
                                {/*            <Button*/}
                                {/*                type="button"*/}
                                {/*                variant="contained"*/}
                                {/*                size="large"*/}
                                {/*                style={{*/}
                                {/*                    marginTop: "20px 0",*/}
                                {/*                    width: "100%",*/}
                                {/*                    backgroundColor: "#4267B2",*/}
                                {/*                    color: "white"*/}
                                {/*                }}*/}
                                {/*                onClick={renderProps.onClick}*/}
                                {/*            >*/}
                                {/*                <FacebookIcon className={classes.buttonIcon}/>*/}
                                {/*                <span>Log in with Facebook</span>*/}
                                {/*            </Button>*/}
                                {/*        )*/}
                                {/*    }*/}
                                {/*/>*/}
                                <Divider variant="middle" style={{margin: "20px 0"}}/>
                                <Typography style={{marginBottom: "20px", textAlign: "center"}}>Don't have an
                                    account?</Typography>
                                <Link to="/auth/registration" style={{textDecoration: 'none'}}>

                                    <Button type="button"
                                            variant="contained"
                                            color="grey"
                                            size="large"
                                            style={{marginTop: "20px 0", width: "100%"}}
                                    >
                                        SIGN UP FOR FREE
                                    </Button>
                                </Link>

                            </CardContent>
                        </form>
                    </>
                );
            }
            return content;
        }
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    theming: state.theming
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {
        login,
        get_clusters,
        clear_login_error,
        auth_with_google,
        set_auth_errors,
        //auth_with_facebook,
        clear_password_change_status,
        clear_forgot_password_status,
        clear_register_success,
        switchMode
    }
)(Login)));
